//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../no/Diagramming.js";
let d=[[[0,"Anchor",1,0],[0,"AnnotationBuilder",1,"Diagramming.CannedAnnotationBuilder",0],[0,"LetteringAngle",1,0],[0,"TextBoxWidth",1,0],[0,"TextOverflow",1,0]],[[["selectedNodes"],"SetSelectedAnnotations",{},1,0],[["settingName","isSettingChanged"],"SetChangedSettings",{},2,0],[[],"ResetAnnotationToDefault",{},0,0]],[]];
SPLM.AME.BulkEditAnnotationBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.BulkEditAnnotationBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;